import { createFunc } from '../controller/assets/sub/createFunc';
//Sass 컴파일
import '../../sass/sub/_create.scss';
//import datePicker
import '../lib/jquery.daterangepicker.min';

export const createList = {
	init:function() {
	},
	userChoiceAddBtn:function(el) {
		var values = $(el).val();
		if(values != "") {
			var valSplit = values.split('~');
			if(valSplit[0] == valSplit[1] || valSplit[1] == undefined) {
				var comment = '하루 데이터를 생성하시겠습니까?'
				if(confirm(comment) == true) {
					createFunc.createAddData(values);
				}else{
					return;
				}
			}else{
				createFunc.createAddData(values);
			}
		}else{
			alert('선택된 날짜가 없습니다.');
		}
	},
	checkSaveBtn:function(el) {
		createFunc.createSaveData();
	},
	listDeleteBtn:function(e) {
		var commentType = $(e).data('comment');
		var typeMsg = (commentType == 'type-1') ? '데이터와 이력을 삭제하시겠습니까?':'데이터 생성을 취소하시겠습니까?';
		if(confirm(typeMsg) == true) {
			var thisEl = e.getAttribute("data-id");
			var thisListId = $('.' + thisEl).attr('data-id');
			createFunc.createListDeleteData(thisListId);
			$('.' + thisEl).remove();
		}else{
			return;
		}
	},
	listAlldeleteBtn:function(el) {
		var eachCheck = null;
		if(confirm('선택 된 데이터와 이력을 삭제하시겠습니까?') == true) {
			$(el).find('tr td .list-check:checked').each(function() {
				eachCheck = true;
				var thisListId = $(this).parents('tr').attr('data-id');
				createFunc.createListDeleteData(thisListId);
				$(this).parents('tr').remove();
			});
			if(eachCheck == null) {
				alert('선택 후 삭제 가능합니다.');
			}
		}else{
			return;
		}
	}
}



//데이터 생성 페이지 단독 액션
window.createList = createList;



// WEBPACK FOOTER //
// ./js/sub/create.js